import React from 'react';
import { BrowserRouter as Router, Route, Link } from "react-router-dom";

import Amplify from 'aws-amplify';
import aws_exports from './aws-exports';

import VideoPlayer from "./components/video_player.jsx"
import logo from './logo.svg';
import './App.css';

import AppBar from './components/app_bar.jsx';
import Drawer from './components/drawer.jsx';

Amplify.configure({ ...aws_exports,
    Auth: {
        identityPoolId: 'us-east-1:14a90835-09a6-46d8-a797-f85392fd3a04',
        region: 'us-east-1',
    }
});

const App = () => (
    <Router>
      <div className="App">
        <Drawer />
      </div>
    </Router>
);



/*
const Clusters = () => {
    const videoJsOptions = {
      autoplay: true,
      controls: true,
      sources: [{
        src: 'https://raw.githubusercontent.com/mediaelement/mediaelement-files/master/big_buck_bunny.mp4',
        type: 'video/mp4'
      }]
    }

    return (
        <div>
            <h2>Clusters</h2>
            <VideoPlayer { ...videoJsOptions } />
        </div>
    );

};

*/

export default App;



// WEBPACK FOOTER //
// ./src/App.js